import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Patient } from 'src/models';
import { api } from 'src/services';

export type UseCreatePatientPayload = {
  first_name: string;
  last_name: string;
  birth_date: string;
  phone?: string;
  email?: string;
  ehr_id?: string;
  photo?: string;
  marital_status?: string;
  preferred_language?: string;
  preferred_name?: string;
  address?: {
    line_1?: string;
    line_2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    address_type?: string;
  };
};

export type CreatePatientResponse = {
  message: string;
  patient: Patient;
};

export const useCreatePatient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UseCreatePatientPayload) =>
      api
        .post<CreatePatientResponse>('/v2/patients', payload)
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patientList'] });
    },
  });
};
